var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "26.5 23.75 147 152.5",
    viewBox: "26.5 23.75 147 152.5",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#comp-kq5dfsen svg [data-color=\"1\"] {fill: #16163F;}\r\n#comp-kq5dfsen svg [data-color=\"2\"] {fill: #DDBBFF;}\r\n#comp-kq5dfsen svg [data-color=\"3\"] {fill: #9E3FFD;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#16163F",
    clipRule: "evenodd",
    fillRule: "evenodd",
    d: "M42 170.25a6 6 0 1 1-12 0 6 6 0 0 1 12 0z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E7EB",
    clipRule: "evenodd",
    fillRule: "evenodd",
    d: "M173.5 103.75c0 31.48-25.52 57-57 57s-57-25.52-57-57 25.52-57 57-57 57 25.52 57 57z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E3FFD",
    clipRule: "evenodd",
    fillRule: "evenodd",
    d: "M116.5 68.75c0 24.853-20.147 45-45 45s-45-20.147-45-45 20.147-45 45-45 45 20.147 45 45z",
    "data-color": 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon2);
export default __webpack_public_path__ + "static/media/ServiceIcon2.26523451404e0581927d649f8f7db9f8.svg";
export { ForwardRef as ReactComponent };